import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from '@guards/auth.guard';
import {NoAuthGuard} from '@guards/no-auth.guard';

const routes: Routes = [
  {path: '', canActivate: [AuthGuard], loadChildren: () => import('./container/container.module').then(m => m.ContainerModule)},
  {path: '', canActivate: [NoAuthGuard], loadChildren: () => import('./login/login.module').then(m => m.LoginModule)},
  {path: '**', redirectTo: '', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    paramsInheritanceStrategy: 'always'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
